import { Dialog, makeStyles } from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import MaterialTable from "material-table";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { WidgetForDevices } from "../../../../_metronic/_partials/widgets/mixed/WidgetForDevices";
import {
  CommonUrl, logoutMsg, myHeaderStyle, mySearchFieldStyle, NONCE,
  processMsg,
  TIME_STAMP
} from "../../../common-url/CommonUrl";
import DeviceForm from "../component/DeviceForm";


const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiInput-underline:before": {
      borderBottom: 0,
    },
    "& .MuiInput-underline:after": {
      borderBottom: 0,
    },
    "& .MuiInput-root": {
      borderBottom: 0,
    },
    "&:last-child td": {
    },
  }
}));


export default function DevicesList() {
  const [devices, setDevices] = useState([]);
  const [total, setTotal] = useState();
  const [active, setActive] = useState();
  const [inActive, setInActive] = useState();
  const classes = useStyles();

  const columns = [
    {
      title: "Serial Number",
      field: "vDeviceSerialNo",
      filterPlaceholder: "Serial Number",
      components: {
        FilterRow: props => <input className="form-control"></input>
      }
    },
    {
      title: "Type",
      field: "tiDeviceType",
      filterPlaceholder: "Type",
      lookup: { 1: "8-Switch Panel", 2: "4-Switch Panel", 3: "3-Pin Switch Panel" },
      initialEditValue: 1
    },
    {
      title: "Status",
      field: "tiDeviceStatus",
      filterPlaceholder: "Status",
      lookup: { 0: "Inactive", 1: "Active" },
      initialEditValue: 0,
      render: rowData => (
        <div
          className={rowData.tiDeviceStatus ? "text-success " : "text-danger"}
        >
          {rowData.tiDeviceStatus ? "Active" : "Inactive"}
        </div>
      )
    },
    {
      title: "Firmware Version",
      field: "vFirmwareVersion",
      filterPlaceholder: "FW"
    },
    {
      title: "Product Group",
      field: "vProductGroup",
      filterPlaceholder: "Group",
    },
    {
      title: "Activation Date",
      field: "vDateOfActivation",
      type: "date",
      editable: false,
      filterPlaceholder: "Activation Date"
    },
    {
      title: "Manufacturing Date",
      field: "vManufactureDate",
      type: "date",
      filterPlaceholder: "Mfg Date",
      format: "dd/MM/yyyy"
    },
    {
      title: "Updated At",
      field: "iUpdatedAt",
      editable: false,
      filtering: false,
      defaultSort: "desc",
      hidden: true,
      render: rowData => (
        <span>
          {moment(rowData.iUpdatedAt * 1000).format("MMMM Do YYYY, h:mm:ss a")}
        </span>
      )
    }
  ];
  // ------------------------------------------------------------
  //--------get the all devices list at initial loading----------
  // ------------------------------------------------------------
  const myTextIcon = React.useRef(null);

  useEffect(() => {
    fetchDevices();
    myTextIcon.current.parentNode.parentNode.classList.remove('MuiIconButton-root');

  }, []);
  const encToken = useSelector(({ auth }) => auth.authToken, shallowEqual);
  const history = useHistory();

  const fetchDevices = async () => {
    await fetch(CommonUrl.devicesBaseUrl + "/get-all-devices", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      }
    })
      .then(response => response.json())
      .then(response => {
        if (response.code == 401) {
          history.push("/logout");
          toast.info(logoutMsg, { autoClose: 5000 })
        } else {
          setDevices(response.data);
          setTotal(response.totalDevices);
          setActive(response.activeDevices);
          setInActive(response.inActiveDevices);
        }

      });
  };

  // ------------------------------------------------------------
  //-------------------- delete device---------------------------
  // ------------------------------------------------------------

  const handleRowDelete = vDeviceSerialNo => {
    const id = toast.loading(processMsg);
    fetch(CommonUrl.devicesBaseUrl + "/delete-device", {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      },
      body: JSON.stringify({
        vDeviceSerialNo: vDeviceSerialNo
      })
    })
      .then(response => response.json())
      .then(response => {
        if (response.code === 200) {
          toast.update(id, {
            render: response.message,
            type: "success",
            isLoading: false,
            autoClose: 3000
          });
          fetchDevices();
        } else {
          toast.update(id, {
            render: response.message,
            type: "error",
            isLoading: false,
            autoClose: 3000
          });
        }
      });
  };

  // ---------------------------------------------------------------
  //                             manage form
  // ---------------------------------------------------------------

  const [openForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState({});

  const addDevice = () => {
    setOpenForm(true);
  };
  const handleUpdateForm = rowData => {
    setFormData(rowData);
    setOpenForm(true);
  };

  // ------------------------------------------------------------
  // snackbar operations starts
  // ------------------------------------------------------------
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenForm(false);
    setTimeout(() => {
      setFormData({});
    }, 200);
  };

  return (
    <>
      <div className="pb-5">
        <WidgetForDevices total={total} active={active} inActive={inActive} />
      </div>
      <div className="App">
        <Dialog
          open={openForm}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DeviceForm data={formData}></DeviceForm>
        </Dialog>

        {/* material table starts */}
        <div className={classes.root} >

          <MaterialTable
            style={{ paddingInline: "30px", paddingTop: "10px" }}
            title="Available Devices"
            data={devices}
            columns={columns}
            actions={[
              {
                icon: () => <div ref={myTextIcon}><button className="btn  btn-light-primary mx-6">Add +</button></div>,
                iconProps: { color: "secondary" },
                tooltip: "Add Device",
                isFreeAction: true,
                onClick: () => {
                  addDevice();
                }
              },
              // {
              //   icon: "edit",
              //   iconProps: { color: "secondary" },
              //   tooltip: "Update Device",
              //   onClick: (e, rowData) => {
              //     handleUpdateForm(rowData);
              //   }
              // }
            ]}
            icons={{
              Delete: () => <DeleteOutlineIcon style={{ color: "#f64e60" }} />
            }}
            editable={{
              onRowDelete: selectedRow =>
                new Promise((resolve, reject) => {
                  const vDeviceSerialNo = selectedRow.vDeviceSerialNo;
                  handleRowDelete(vDeviceSerialNo);
                  resolve();
                })
            }}
            options={{
              fixedColumns: {
                left: 1
              },
              filtering: false,
              actionsColumnIndex: -1,
              addRowPosition: "first",
              headerStyle: myHeaderStyle,
              searchFieldStyle: mySearchFieldStyle,
              emptyRowsWhenPaging: false, // To avoid of having empty rows
            }}
          />
        </div>
      </div>
    </>
  );
}
